document.addEventListener('DOMContentLoaded', function () {
    var mobileSlider = $('.mobile-slider');
    var desktopSlider = $('.desktop-slider');

    if ($(window).width() < 768 && mobileSlider.length) {
        mobileSlider.slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            autoplay: true,
            arrows: false,
            dir: "ltr" 

        });
    }

    if ($(window).width() >= 768 && desktopSlider.length) {
        desktopSlider.slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            autoplay: true,
            arrows: false,
            dir :"ltr" 
        });
    }

    $(window).on('resize', function () {
        if ($(window).width() < 768 && !mobileSlider.hasClass('slick-initialized')) {
            mobileSlider.slick({
                dots: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                autoplay: true,
                arrows: false,
                dir: "ltr" 


            });
        } else if ($(window).width() >= 768 && !desktopSlider.hasClass('slick-initialized')) {
            desktopSlider.slick({
                dots: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                autoplay: true,
                arrows: false,
                dir: "ltr" 


            });
        }
    });
});